import { Invoice } from '../../../models/Invoice/Invoice.js';
import { InvoiceDownload } from '../../../models/Invoice/InvoiceDownload.js';

class Invoices {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(page, size) {
    return this.apiClient.get('v1/invoices', {
      page,
      size
    }).then(response => {
      const {
        invoices,
        pagination
      } = response.data;
      return {
        invoices: invoices.map(Invoice.createFromResponse),
        pagination: {
          currentPage: pagination.current_page,
          totalElements: pagination.total_registers,
          totalPages: pagination.total_pages
        }
      };
    });
  }
  download(invoiceId) {
    return this.apiClient.get(`v1/invoices/${invoiceId}/download`).then(response => InvoiceDownload.createFromResponse(response.data));
  }
}

export { Invoices };
//# sourceMappingURL=Invoices.js.map
